<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">City Circle List</h1>
	    </div>
	</div>
</div>    

<div class="container-fluid px-4 pt-4 card">
    <div>
        
    </div>
    <div class="">
        <div cdkDropListGroup class="boxwidth">
            <div class="example-container">
              <h2 class="mb-0">Assigned cities - ({{circleName}})</h2>
              <div class="invalid-feedback p-1 position-absolute col-lg-6" *ngIf="noCities && !allassignedcities.length">Please select atleast one city</div>
              <input class="mySearchInput"
                 focused="'true'" type="text"
                (keyup)="searchOnSelect($event.target.value, 'assignedcity')"
                (keydown)="$event.stopPropagation()" autocomplete="off"
                placeholder="Search"
                id="circleSearch">  
              <div
                cdkDropList
                [cdkDropListData]="allassignedcities"
                class="example-list"
                (cdkDropListDropped)="drop($event)" >
                <div class="example-box" *ngFor="let item of allassignedcities" cdkDrag>{{item.name}}</div>
                <div class="example-box" *ngIf="!allassignedcities.length">No Cities Found!</div>
              </div>
            </div>

            <div class="example-container">
                <h2 class="mb-0">All cities</h2>
                <input class="mySearchInput"
                 focused="'true'" type="text"
                (keyup)="searchOnSelect($event.target.value, 'allcity')"
                (keydown)="$event.stopPropagation()" autocomplete="off"
                placeholder="Search"
                id="circleSearch">
                <div
                  cdkDropList
                  [cdkDropListData]="cities"
                  class="example-list"
                  cdkDropListSortingDisabled
                  (cdkDropListDropped)="drop($event)">
                  <div class="example-box" *ngFor="let city of cities" cdkDrag>{{city.name}}</div>
                </div>
              </div>
            <button class="btn btn-default cityBtn" type="button" routerLink="/manage-circle-city">  Cancel</button>  
            <button class="btn btn-primary citycancleBtn" type="button" (click)="updateData()"> <i class="fa fa-spin fa-spinner fa-2x" *ngIf="loading"></i> Update</button>
            
          </div>
    </div>
</div>        
